<template>
    <div class="page-user-integral">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">會員管理</div>
            <div class="breadcrumb-item">積分操作</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-box">
                <Row>
                    <Col span="18" push="3">
                    <Form :label-width="150">
                        <FormItem v-if="this.user_admin == 0">
                            <div slot="label" class="form-label">
                                <em class="red">* </em>
                                <span>充值方式</span>
                            </div>
                            <Select size="small" style="width: 120px;" placeholder="選擇充值方式" v-model="online" @on-change="handleStoreChange(online)">
                                <Option :value="1">線上APP/智能櫃</Option>
                                <Option :value="2">門店</Option>
                            </Select>
                        </FormItem>
                        
                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>會員名稱</span>
                            </div>
                            <div class="text-value">{{detail.user_name}}</div>
                        </FormItem>

                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>客戶電話</span>
                            </div>
                            <div class="text-value">{{detail.phone}}</div>
                        </FormItem>

                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>提貨櫃點</span>
                            </div>
                            <div class="text-value">{{detail.ReceivingName}}</div>
                        </FormItem>

                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>總積分</span>
                            </div>
                            <div class="text-value">{{detail.user_integral + detail.user_integral_tw}}</div>
                        </FormItem>

                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>基本積分</span>
                            </div>
                            <div class="text-value">{{detail.user_integral}}</div>
                        </FormItem>
                        
                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>贈送積分</span>
                            </div>
                            <div class="text-value">{{detail.user_integral_tw}}</div>
                        </FormItem>

                        <FormItem>
                            <div slot="label" class="form-label">
                                <span>集金幣</span>
                            </div>
                            <div class="text-value">{{detail.Jpoint}}</div>
                        </FormItem>

                        <FormItem>
                            <div slot="label" class="form-label">
                                <em class="red">* </em>
                                <span>操作積分</span>
                            </div>
                            <InputNumber style="width: 20%" :max="10000" :min="1" v-model="form.integral"></InputNumber>
                            <RadioGroup v-model="form.integral" :value="item.id" v-for="(item, index) in creditlist"
                                :key="item.id" style="margin-left: 10px">
                                <Radio :label="item.price" >{{item.price}}送{{item.extra_credit}}</Radio>
                            </RadioGroup>
                        </FormItem>
                        
                        <FormItem v-if="this.online == 1">
                            <div v-model="form.integral" :value="item.id" v-for="(item, index) in creditlist"
                                :key="item.id">
                                <span style="color:red;">{{item.amount_type.type | filtertype}} {{item.price}}送{{item.extra_credit}} </span>
                            </div> 
                        </FormItem>

                        <FormItem v-if="this.online == 2">
                            <div v-model="form.integral" :value="item.id" v-for="(item, index) in creditlist"
                                :key="item.id">
                                <span style="color:red;">{{item.amount_type.type | filtertype}} {{item.price}}送{{item.extra_credit}} </span>
                            </div> 
                        </FormItem>
                        
                        <FormItem>
                            <div slot="label" class="form-label">

                                <span>門店員工</span>
                            </div>
                            <span style="width: 50%">
                                {{form.remarks.username}}
                            </span>
                            
                        </FormItem>

                        <FormItem v-if="this.user_admin == 0">
                            <div slot="label" class="form-label">
                                <em class="red">* </em>
                                <span>備註說明</span>
                            </div>
                            <Input v-model="form.describe" style="width: 50%"></Input>
                        </FormItem>

                        <FormItem>
                            <div class="pg-btn-wrap">
                                <div class="pg-btn style1" @click="handleCheckForm">確定</div>
                                <div class="pg-btn" @click="handleBack">返回</div>
                                <!-- <Button type="error" :loading="true" class="loading-btn">
                                     <span>Loading...</span>
                                 </Button>-->
                            </div>
                        </FormItem>
                    </Form>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
    
</template>

<script>
    import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                pageParam: {},
                detail: {},
                creditlist: [],
                isSubmiting: false,
                willShow:false,
                online: 2,
                default: 2,
                form: {
                    type: 1,  // 操作类型1充值2赠送3消费
                    integral: '',    //操作积分
                    describe: '',//操作描述
                    remarks: Store.fetch()
                },
                user_admin: Store.fetch().store_id,
            };
        },
        filters:{
            filtertype(value){
                if(value == 1){
                    return '贈送積分';
                }
                if(value == 2){
                    return '贈送集金幣';
                }
            },
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getCredit(this.online);
            this.getDetail();
        },
        methods: {
            handleStoreChange(index) {
                this.form.describe = '';
                this.form.integral = '';
                this.getCredit(index);
            },
            getCredit(index)
            {

                this.$Rq.requestAuth({
                    url: this.$Api.creditAdminList,
                    method: 'get',
                    data: {
                        is_online: index
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.creditlist = res.data.data;
                    }
                });
            },
            handleBack()
            {
                this.$router.go(-1);
            },
            getDetail()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.userList + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        let resData = res.data;
                        this.detail = resData;
                    }
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.type === '')
                {
                    this.$Utils.showTipInfo('請選擇操作類型');
                    return;
                } else if (form.integral === '')
                {
                    this.$Utils.showTipInfo('請輸入操作積分');
                    return;
                } else if(this.user_admin == 0){
                    if(form.describe === ''){
                        this.$Utils.showTipInfo('請輸入備註說明');
                        return;
                    }
                }

                this.handleSubmit();
                // form.describe = '';
            },
            handleSubmit()
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '對 ' + this.detail.user_name + ' 用戶增加 ' + this.form.integral+' 積分嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () => {
                        let form = this.form;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.integralNewAdd,
                            method: 'post',

                            data: {
                                user_id: parseInt(this.pageParam.id),
                                type: Number(this.online),  // 操作類型 1.充值 2.赠送 3.消费
                                integral: Number(form.integral),  //操作積分
                                // article_id: Number(form.article_id), //關聯活動
                                describe: form.describe,    //操作描述
                                remarks: Store.fetch().username,
                            }
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);
                                this.getDetail();
                                form.integral = '';
                                form.describe = '';
                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                                this.getDetail();
                                form.integral = '';
                                form.describe = '';
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                            form.integral = '';
                            form.describe = '';
                        });
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "shopUserIntegral.scss";
</style>